import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import Swal from "sweetalert2";

const BlogAdmin = () => {
  const [estado, setEstado] = useState("ver");
  const [posts, setPosts] = useState([]);
  const [postEnEdicion, setPostEnEdicion] = useState(null);
  const token = localStorage.getItem("token");
  const [nuevoPost, setNuevoPost] = useState({
    titulo: "",
    contenido: "",
    imagen1: null,
    imagen2: null,
    imagen3: null,
  });
  const navigate = useNavigate();
  const fetchPost = async () => {
    try {
      const response = await fetch("https://ricardodiaztuasesorfinanciero.com/api/posts", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
      setPosts(data);
    } catch (error) {
      console.error("Error al obtener los posts:", error);
    }
  };

  useEffect(() => {
    fetchPost();
  }, []);

  const handleImagenChange = (e, imagenKey) => {
    const file = e.target.files[0];
    setNuevoPost(prev => ({ ...prev, [imagenKey]: file }));
  };

  const handleEdicionImagenChange = (e, imagenKey) => {
    const file = e.target.files[0];
    setPostEnEdicion(prev => ({ ...prev, [imagenKey]: file }));
  };

  const crearPost = async () => {
    const formData = new FormData();
    formData.append("titulo", nuevoPost.titulo);
    formData.append("contenido", nuevoPost.contenido);
    if (nuevoPost.imagen1) formData.append("imagen1", nuevoPost.imagen1);
    if (nuevoPost.imagen2) formData.append("imagen2", nuevoPost.imagen2);
    if (nuevoPost.imagen3) formData.append("imagen3", nuevoPost.imagen3);

    try {
      const res = await fetch("https://ricardodiaztuasesorfinanciero.com/api/crearpost", {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });
      const data = await res.json();
      if (data.ok) {
        fetchPost();
        setEstado("ver");
      } else {
        Swal.fire({
              title: "No se pudo crear el post.",
              icon: "error",
              draggable: true
            });
      }
    } catch (error) {
      console.error("Error creando post:", error);
    }
  };

  const guardarCambio = async () => {
    const formData = new FormData();
    formData.append("id", postEnEdicion.id);
    formData.append("titulo", postEnEdicion.titulo);
    formData.append("contenido", postEnEdicion.contenido);
    if (postEnEdicion.imagen1 instanceof File)
      formData.append("imagen1", postEnEdicion.imagen1);
    if (postEnEdicion.imagen2 instanceof File)
      formData.append("imagen2", postEnEdicion.imagen2);
    if (postEnEdicion.imagen3 instanceof File)
      formData.append("imagen3", postEnEdicion.imagen3);

    try {
      const res = await fetch("https://ricardodiaztuasesorfinanciero.com/api/guardarcambio", {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });
      const data = await res.json();
      if (data.ok) {
        fetchPost();
        setPostEnEdicion(null);
        setEstado("ver");
      } else {
        alert("Error al guardar cambios");
      }
    } catch (error) {
      console.error("Error guardando cambios:", error);
    }
  };

const eliminarPost = async (id) => {
  const resultado = await Swal.fire({
    title: "¿Estás seguro?",
    text: "Esta acción eliminará el post permanentemente.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#c53030",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Sí, eliminar",
    cancelButtonText: "Cancelar",
  });

  if (!resultado.isConfirmed) return;

  if (!token) {
    Swal.fire("Error", "No se encontró el token de autenticación. [N1]", "error");
    return;
  }

  try {
    const res = await fetch("https://ricardodiaztuasesorfinanciero.com/api/eliminarpost", {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ id }),
    });

    const data = await res.json();
    console.log(data);

if (res.ok && data.message?.toLowerCase().includes("eliminado")) {
    Swal.fire({
        title: "¡Post eliminado!",
        text: "El post ha sido eliminado correctamente.",
        icon: "success",
        timer: 2000,
        showConfirmButton: false
    });
    fetchPost();
} else {
    Swal.fire("Error", data?.message || "No se pudo eliminar el post. [N3]", "error");
}

  } catch (error) {
    console.error("Error eliminando post:", error);
    Swal.fire("Error", "Ocurrió un error en la conexión. [N5]", "error");
  }
};


  const styles = {
    container: {
      padding: "50px 40px",
      fontFamily: "Segoe UI, sans-serif",
      backgroundColor: "#f2f6fa",
      minHeight: "100vh",
    },
    header: {
      backgroundColor: "#102a43",
      color: "white",
      padding: "20px",
      borderRadius: "12px",
      marginBottom: "30px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    title: {
      fontSize: "24px",
      fontWeight: "bold",
    },
    button: {
      margin: "0 10px",
      padding: "10px 20px",
      backgroundColor: "#334e68",
      color: "white",
      border: "none",
      borderRadius: "8px",
      cursor: "pointer",
    },
    postCard: {
      backgroundColor: "#fff",
      borderRadius: "10px",
      boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
      padding: "20px",
      marginBottom: "20px",
    },
    postTitle: {
      fontWeight: "bold",
      fontSize: "20px",
      color: "#102a43",
    },
    postContent: {
      margin: "10px 0",
      fontSize: "16px",
    },
    image: {
      width: "180px",
      height: "auto",
      marginRight: "10px",
      borderRadius: "8px",
    },
    input: {
      display: "block",
      width: "100%",
      padding: "10px",
      margin: "10px 0",
      borderRadius: "8px",
      border: "1px solid #ccc",
    },
    actionButtons: {
      display: "flex",
      gap: "10px",
      marginTop: "10px",
    },
    formContainer: {
      backgroundColor: "#fff",
      borderRadius: "12px",
      padding: "20px",
      boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
      marginBottom: "30px",
    },
    botonera: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '10px',
    justifyContent: 'center',
    marginTop: '15px',
  },
  botonRegresar: {
    backgroundColor: '#334e68',
    border: 'none',
    color: 'white',
    padding: '10px 20px',
    borderRadius: '8px',
    cursor: 'pointer',
    marginLeft: '10px',
  },
  buttonActivo: {
    backgroundColor: '#486581',
    color: 'white',
    padding: '10px 18px',
    border: '2px solid white',
    borderRadius: '8px',
    cursor: 'pointer',
    fontWeight: 'bold',
    fontSize: '0.95rem'
  }
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h2 style={styles.title}>📝 Administrador de Blog</h2>
        <div style={styles.botonera}>
          <button style={styles.botonRegresar} onClick={() => navigate('/')}>🏠 Menú Principal</button>
          <button style={styles.botonRegresar} onClick={() => navigate('/CitasClientes')}>📆 Citas Pendientes</button>
          <button style={styles.botonRegresar} onClick={() => navigate('/citasdespues')}>👥 Citas Finalizadas</button>
          <button style={styles.botonRegresar} onClick={() => navigate('/adminseguros')}>📃 Formularios</button>
          <button style={styles.botonRegresar} onClick={() => navigate('/horariosadmin')}>🕒 Horarios</button>
          <button style={styles.botonRegresar} onClick={() => setEstado("crear")}>➕ Crear Post</button>
          <button style={styles.botonRegresar} onClick={() => setEstado("ver")}>📄 Ver Posts</button>
          <button style={styles.botonRegresar} onClick={() => navigate('/aiuda')}>⚙️ Ayuda</button>
        </div>
      </div>

      {estado === "crear" && (
        <div style={styles.formContainer}>
          <input
            type="text"
            placeholder="Título del Post"
            value={nuevoPost.titulo}
            onChange={(e) => setNuevoPost({ ...nuevoPost, titulo: e.target.value })}
            style={styles.input}
          />
          <textarea
            placeholder="Contenido del Post"
            value={nuevoPost.contenido}
            onChange={(e) => setNuevoPost({ ...nuevoPost, contenido: e.target.value })}
            style={styles.input}
          />
          <input type="file" accept="image/*" onChange={(e) => handleImagenChange(e, "imagen1")} />
          <input type="file" accept="image/*" onChange={(e) => handleImagenChange(e, "imagen2")} />
          <input type="file" accept="image/*" onChange={(e) => handleImagenChange(e, "imagen3")} />
          <button style={{ ...styles.button, marginTop: "10px" }} onClick={crearPost}>✅ Publicar</button>
        </div>
      )}

      {estado === "ver" &&
        posts.map((post) => (
          <div key={post.id} style={styles.postCard}>
            <h3 style={styles.postTitle}>{post.titulo}</h3>
            <p style={styles.postContent}>{post.contenido}</p>
            <div style={{ display: "flex", flexWrap: "wrap", marginBottom: "10px" }}>
              {post.imagen1 && <img src={`data:image/jpeg;base64,${post.imagen1}`} alt="imagen1" style={styles.image} />}
              {post.imagen2 && <img src={`data:image/jpeg;base64,${post.imagen2}`} alt="imagen2" style={styles.image} />}
              {post.imagen3 && <img src={`data:image/jpeg;base64,${post.imagen3}`} alt="imagen3" style={styles.image} />}
            </div>
            <div style={styles.actionButtons}>
              <button style={styles.button} onClick={() => { setEstado("editar"); setPostEnEdicion(post); }}>✏️ Editar</button>
              <button style={{ ...styles.button, backgroundColor: "#c53030" }} onClick={() => eliminarPost(post.id)}>🗑️ Eliminar</button>
            </div>
          </div>
        ))}

      {estado === "editar" && postEnEdicion && (
        <div style={styles.formContainer}>
          <input
            type="text"
            value={postEnEdicion.titulo}
            onChange={(e) => setPostEnEdicion({ ...postEnEdicion, titulo: e.target.value })}
            style={styles.input}
          />
          <textarea
            value={postEnEdicion.contenido}
            onChange={(e) => setPostEnEdicion({ ...postEnEdicion, contenido: e.target.value })}
            style={styles.input}
          />
          <input type="file" accept="image/*" onChange={(e) => handleEdicionImagenChange(e, "imagen1")} />
          <input type="file" accept="image/*" onChange={(e) => handleEdicionImagenChange(e, "imagen2")} />
          <input type="file" accept="image/*" onChange={(e) => handleEdicionImagenChange(e, "imagen3")} />
          <div style={styles.actionButtons}>
            <button style={styles.button} onClick={guardarCambio}>💾 Guardar</button>
            <button style={{ ...styles.button, backgroundColor: "#999" }} onClick={() => { setEstado("ver"); setPostEnEdicion(null); }}>❌ Cancelar</button>
          </div>
          
        </div>
      )}
      
    </div>
  );
};

export default BlogAdmin;
